const IconDelete = () =>{
    return(
        
        <svg width="32px" height="25px" viewBox="0 0 32 25">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-89.366238, -197.500000)" stroke="#405363">
                    <g transform="translate(80.000000, 120.000000)">
                        <g transform="translate(0.000000, 60.000000)">
                            <path d="M20,18 L40,18 L40,42 L18.75,42 L10,30 L20,18 Z M25.2418152,25.7435423 L33.7270966,34.2288237 M25.2418152,34.2288237 L33.7270966,25.7435423"></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default IconDelete;